import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createSmsTemplate,
  deleteSmsTemplate,
  getSmsTemplates,
  updateSmsTemplate,
} from "api/bMarketingApi";

function normalizeSmsTemplate(template) {
  return {
    ...template,
    databaseId: template.id,
    id: template.template_id,
    senderName: template.sender_name || "",
    createdAt: template.created_at,
    updatedAt: template.updated_at,
    attachmentImageUrl: template.attachment_image_url || "",
    attachmentImageName: template.attachment_image_name || "",
  };
}

export function useMarketingSmsTemplates(organisationId) {
  const queryClient = useQueryClient();

  const { data: smsTemplates, isLoading, error } = useQuery({
    queryKey: ["smsTemplates", organisationId],
    queryFn: () => getSmsTemplates(organisationId).then((res) => res.data.map(normalizeSmsTemplate)),
    enabled: !!organisationId,
  });

  const createMutation = useMutation({
    mutationFn: (data) => createSmsTemplate(data).then((res) => normalizeSmsTemplate(res.data)),
    onSuccess: () => {
      queryClient.invalidateQueries(["smsTemplates", organisationId]);
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ templateId, data }) => updateSmsTemplate(templateId, data).then((res) => normalizeSmsTemplate(res.data)),
    onSuccess: () => {
      queryClient.invalidateQueries(["smsTemplates", organisationId]);
    },
  });

  const deleteMutation = useMutation({
    mutationFn: deleteSmsTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries(["smsTemplates", organisationId]);
    },
  });

  return {
    smsTemplates: smsTemplates || [],
    isLoading,
    error,
    createTemplate: createMutation.mutate,
    createTemplateAsync: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
    updateTemplate: updateMutation.mutate,
    updateTemplateAsync: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
    deleteTemplate: deleteMutation.mutate,
    deleteTemplateAsync: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
  };
}